import { confirm } from "lib/ConfirmationModal/ConfirmationModal";
import { TeamTemplateSize } from "state/entities/teamTemplateSizes/teamTemplateSizesActions";
import style from "./style.module.css";

interface ConfirmDeleteArgs {
  size: TeamTemplateSize;
  onConfirm: () => void;
  onCancel?: () => void;
}

const confirmDeleteTeamTemplateSize = ({
  size,
  onConfirm,
  onCancel
}: ConfirmDeleteArgs): void => {
  confirm({
    header: "Delete Team Size?",
    text: `Are you sure you want to delete "${size.name}"? Team members will no longer be able to pick this size.`,
    onOk: onConfirm,
    onCancel,
    buttonsDetails: {
      ok: {
        theme: "redSolid",
        className: style.button,
        name: "Delete"
      },
      cancel: {
        theme: "gray",
        className: style.button,
        name: "Cancel"
      },
      buttonsClassName: style.deleteConfirmationModalButtons
    },
    modalClassName: style.deleteConfirmationModal
  });
};

export default confirmDeleteTeamTemplateSize;
